<template>
  <div class="app-title">
    <b-row v-if="$slots.after">
      <b-col v-if="$slots.before" md="auto">
        <slot name="before"> </slot>
      </b-col>
      <b-col>
        <h1><slot name="default"></slot></h1>
      </b-col>
      <b-col md="auto">
        <slot name="after"> </slot>
      </b-col>
    </b-row>
    <h1 v-if="!$slots.after"><slot name="default"></slot></h1>
  </div>
</template>
<script>
export default {
  name: 'rdkm-title',
  props: ['name', 'className'],
  updated() {
    if (this.$slots.default[0] && this.$slots.default[0].text) {
      document.title = 'SCDB | ' + this.$slots.default[0].text.trim();
    }
  },
};
</script>

<style>
.app-title {
  display: inherit;
  margin: 0px;
}
</style>
